	import { stringOptionalSchema, stringRequiredSchema, urlSchema } from "utils/validation/validationHelpers";
	import { object } from 'yup';

	const bannerSchema = object().shape({
		title: stringRequiredSchema,
		description: stringRequiredSchema,
		link_url: urlSchema({required: true}),
		from_date: stringRequiredSchema,
		to_date: stringRequiredSchema,
		banner_image: stringRequiredSchema,
	});

	export default bannerSchema;